import GroupContactItem from './GroupContact';

export { default } from './ContactItem';
export { GroupContactItem };



// WEBPACK FOOTER //
// ./src/components/Search/ContactSearch/ContactList/ContactBucket/ContactItem/index.js